import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./styles.css";
import { initCapacitor } from "./capacitor";

initCapacitor();
createRoot(document.getElementById("root")).render(<App />);
